// Screens that lay themselves out for any window size (the admin panel) turn
// off ResponsiveProvider's 16:9 frame while they're shown; the POS keeps it
export const FLUID_LAYOUT_EVENT = "fluid-layout-change";

export const isFluidLayout = () =>
  document.documentElement.dataset.fluidLayout === "true";

export const setFluidLayout = (fluid: boolean) => {
  if (fluid) document.documentElement.dataset.fluidLayout = "true";
  else delete document.documentElement.dataset.fluidLayout;
  window.dispatchEvent(new Event(FLUID_LAYOUT_EVENT));
};
